namespace GeniuzPOS.AdvPromo {
    export namespace PsAdvPromoItem6Service {
        export const baseUrl = 'AdvPromo/PsAdvPromoItem6';

        export declare function Create(request: Serenity.SaveRequest<PsAdvPromoItem6Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Update(request: Serenity.SaveRequest<PsAdvPromoItem6Row>, onSuccess?: (response: Serenity.SaveResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Delete(request: Serenity.DeleteRequest, onSuccess?: (response: Serenity.DeleteResponse) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function Retrieve(request: Serenity.RetrieveRequest, onSuccess?: (response: Serenity.RetrieveResponse<PsAdvPromoItem6Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;
        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<PsAdvPromoItem6Row>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            Create = "AdvPromo/PsAdvPromoItem6/Create",
            Update = "AdvPromo/PsAdvPromoItem6/Update",
            Delete = "AdvPromo/PsAdvPromoItem6/Delete",
            Retrieve = "AdvPromo/PsAdvPromoItem6/Retrieve",
            List = "AdvPromo/PsAdvPromoItem6/List"
        }

        [
            'Create', 
            'Update', 
            'Delete', 
            'Retrieve', 
            'List'
        ].forEach(x => {
            (<any>PsAdvPromoItem6Service)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
